import IInitialSettingsViewModel from '@/models/interfaces/IInitialSettingsViewModel';
import InitialSettingsViewModel from '@/models/InitialSettingsViewModel';
import ValuationInitialSettings from '@/models/valuation/ValuationInitialSettings';
import IInitialSettingState from './interfaces/initial-settings-state.d';

export default class InitialSettingState implements IInitialSettingState {
  public initialSettings: IInitialSettingsViewModel = new InitialSettingsViewModel();

  public valuationInitialSettings: ValuationInitialSettings = new ValuationInitialSettings();
}
